var English = "Inglese";
var French = "Francese";
var German = "Tedesco";
var Italian = "Italiano";
var Japanese = "Giapponese";
var Korean = "Coreano";
var Portuguese = "Portoghese";
var Russian = "Russo";
var Spanish = "Spagnolo";
var Bahasa = "Indonesiano";
var Thai = "Tailandese";
var Vietnamese = "Vietnamita";
var Turkish = "Turco";
var Arabic = "Arabo";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Cinese semplificato",
	"Chinese-Traditional": "Cinese tradizionale",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
